module.exports = __webpack_public_path__ + "fb9d7a7ef29a81fb66d2d62a1b6980b5.svg";